import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, MapPin } from "lucide-react";

const LINES = ["Onde a serra", "encontra", "o descanso."];

export default function Hero({ onReserve }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
    const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0.2]);

    return (
        <section ref={ref} id="topo" data-testid="hero-section" className="relative h-screen min-h-[640px] overflow-hidden grain">
            <motion.div style={{ y }} className="absolute inset-0 scale-110">
                <img
                    src="https://images.unsplash.com/photo-1500964757637-c85e8a162699?q=80&w=2400&auto=format&fit=crop"
                    alt="Pôr do sol na serra"
                    className="h-full w-full object-cover"
                />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />

            <motion.div
                style={{ opacity }}
                className="relative z-10 h-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col justify-end pb-24 md:pb-32"
            >
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="flex items-center gap-2 text-stone-200 text-xs font-bold uppercase tracking-[0.3em] mb-6"
                    data-testid="hero-location"
                >
                    <MapPin size={14} /> Moeda · Minas Gerais
                </motion.p>

                <h1 className="text-stone-50 font-black tracking-tighter leading-[0.95] text-5xl sm:text-7xl lg:text-8xl">
                    {LINES.map((line, i) => (
                        <span key={line} className="block overflow-hidden pb-1">
                            <motion.span
                                className="block"
                                initial={{ y: "110%" }}
                                animate={{ y: "0%" }}
                                transition={{ duration: 1, delay: 0.35 + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
                            >
                                {line}
                            </motion.span>
                        </span>
                    ))}
                </h1>

                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 1 }}
                    className="mt-6 max-w-xl text-stone-200 text-base md:text-lg leading-relaxed"
                    data-testid="hero-subtitle"
                >
                    Dois chalés boutique com hidromassagem, piscina spa aquecida e café da manhã e jantar inclusos — a poucos minutos de Belo Horizonte.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 1.15 }}
                    className="mt-10 flex flex-wrap items-center gap-4"
                >
                    <button
                        data-testid="hero-reserve-button"
                        onClick={onReserve}
                        className="group bg-stone-50 text-emerald-950 text-sm font-bold uppercase tracking-widest px-8 py-4 hover:bg-emerald-900 hover:text-stone-50 transition-colors duration-300 flex items-center gap-3"
                    >
                        Fazer reserva
                        <ArrowDown size={16} className="transition-transform duration-300 group-hover:translate-y-1" />
                    </button>
                    <span className="text-stone-300 text-xs uppercase tracking-widest">
                        Check-in 12h · Check-out 16h
                    </span>
                </motion.div>
            </motion.div>
        </section>
    );
}
